import React from 'react';
import selfie from '../Assets/selfie.jpg';
import '../Styles/Homepage.css';


export default function Homepage() {
    return (
        <main>
            <div className='container'>
                <section className = 'container__left'> 
                <div className = "left_wrapper">
                <h3> Hello, my name is </h3>
                <h2> Deja Drummer </h2>
                <h4>Your next </h4> 
                <div className = 'descrip'>
                    <div className = 'descrip__wrapper'>
                        <div className = 'title'> UI/UX Designer </div>
                        <div className = 'title'> Software Engineer </div>
                        <div className = 'title'> Team Player </div>
                        <div className = 'title'> Profound Employee </div>
                        </div>
                    </div>
                    <p> Let's make the world a better place, one script at a time</p>
                    <div><button className ='left__btn'><a href='#about'> Meet Me </a></button></div>
                </div>
                </section>
                <section className='container__right'>
                <img src={selfie} className='selfie' alt='selfie of Deja Drummer' /> 
                </section>
            </div>
        </main>
    )
}
